import '../__generated__/styles/utils.css';
import React from 'react';
import clsx from 'clsx';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';

var styles = {"ppvx_screenreader":"ppvx_screenreader___1-2-7-beta-0","ppvx_body--no-scrolling":"ppvx_body--no-scrolling___1-2-7-beta-0","ppvx_visible-only-in-context":"ppvx_visible-only-in-context___1-2-7-beta-0","ppvx_text-ellipsis":"ppvx_text-ellipsis___1-2-7-beta-0","ppvx_shimmer":"ppvx_shimmer___1-2-7-beta-0","ppvx_shimmer__animation":"ppvx_shimmer__animation___1-2-7-beta-0","ppvx_shimmer--inverse":"ppvx_shimmer--inverse___1-2-7-beta-0","ppvx_shimmer__defaults":"ppvx_shimmer__defaults___1-2-7-beta-0","ppvx_motion__animation-timing":"ppvx_motion__animation-timing___1-2-7-beta-0","ppvx_motion__transition-timing":"ppvx_motion__transition-timing___1-2-7-beta-0"};

var ScreenReaderContent = function (_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(as, {
    className: clsx(styles.ppvx_screenreader, className)
  }, children);
};

var Shimmer = function (_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      isInverse = _ref.isInverse,
      className = _ref.className,
      _ref$hasStyleDefaults = _ref.hasStyleDefaults,
      hasStyleDefaults = _ref$hasStyleDefaults === void 0 ? true : _ref$hasStyleDefaults,
      children = _ref.children;
  var classes = clsx(styles.ppvx_shimmer, isInverse && styles['ppvx_shimmer--inverse'], hasStyleDefaults && styles.ppvx_shimmer__defaults, className);
  return /*#__PURE__*/React.createElement(as, {
    className: classes
  }, /*#__PURE__*/React.createElement(ScreenReaderContent, {
    as: "span"
  }, children));
};

var withAnimation = function (WrappedComponent) {
  var WCAnimation = function (_ref) {
    var className = _ref.className,
        rest = _objectWithoutProperties(_ref, ["className"]);

    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
      className: clsx(styles['ppvx_motion__animation-timing'], className)
    }, rest));
  };

  WCAnimation.displayName = 'withAnimation';
  return WCAnimation;
};
var withTransition = function (WrappedComponent) {
  var WCTransition = function (_ref2) {
    var className = _ref2.className,
        rest = _objectWithoutProperties(_ref2, ["className"]);

    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
      className: clsx(styles['ppvx_motion__transition-timing'], className)
    }, rest));
  };

  WCTransition.displayName = 'withTransition';
  return WCTransition;
};

export { ScreenReaderContent, Shimmer, withAnimation, withTransition };
